import {createStateMaker} from '@shared/helpers/object'

import {MoneyTokenState} from '../interfaces'

export const getInitialState = (): MoneyTokenState => ({
    type: 'TMONEY',
    billing: {
        pgCp: '',
        pgId: '',
        minimumAmount: null,
        maximumAmount: null,
    },
})

export const makeMock = createStateMaker<MoneyTokenState>(getInitialState)
